// extracted by mini-css-extract-plugin
export default {"badge":"Style_badge__6Ig4Y","memberRate":"Style_memberRate__GHFdR"};